import { formatRate, tempo } from "@/lib/run-metrics";
import type { RunSnapshot } from "@/api/types";

/**
 * Three live-tempo cards: extracted/min, pushed/min, processed/min. All
 * derived from the snapshot history (60 s cadence, sometimes 5 s on
 * progress events). Hidden on terminal runs by the parent.
 */
export function RunTempo({ snapshots }: { snapshots: RunSnapshot[] }) {
  const t = tempo(snapshots);
  return (
    <section className="grid grid-cols-1 sm:grid-cols-3 gap-3">
      <Card
        label="Extracted / min"
        value={formatRate(t.extractedPerMin)}
        sub={
          t.extractedPerHour != null
            ? `${formatRate(t.extractedPerHour)}/hr (last 60m)`
            : "—"
        }
      />
      <Card
        label="Pushed / min"
        value={formatRate(t.pushedPerMin)}
        sub={
          t.pushedPerHour != null
            ? `${formatRate(t.pushedPerHour)}/hr (last 60m)`
            : "—"
        }
        accent
      />
      <Card
        label="Processed / min"
        value={formatRate(t.processedPerMin)}
        sub="last 5m"
      />
    </section>
  );
}

function Card({
  label,
  value,
  sub,
  accent,
}: {
  label: string;
  value: string;
  sub: string;
  accent?: boolean;
}) {
  return (
    <div className="card p-3">
      <div className="text-[10px] uppercase tracking-wide text-muted">
        {label}
      </div>
      <div
        className={`text-2xl font-semibold tabular-nums ${
          accent ? "text-accent" : ""
        }`}
      >
        {value}
      </div>
      <div className="text-[11px] text-muted tabular-nums">{sub}</div>
    </div>
  );
}
